import Requests from './request';

const baseUrl = ""

/**
 * @param channelCode 渠道code
 * @param spaceId 空间code
 */
interface EnableJsapiRequest {
  channelCode: string,
  spaceId: string
}
//开启jsapi授权
export async function enableJsApiAuth(params: EnableJsapiRequest) {
  return Requests.post(baseUrl + '/rest/intercnn/jsapi/channel/enable', {
    ...params,
  }, {})
}



/**
 * @param jsapiName 名称
 * @param functionDesc 描述
 * @param supportSystem 支持的系统
 * @param channelCode 渠道code
 * @param spaceId 当前渠道所在空间ID

 */
interface IAddJsapiRequest {
  jsapiName: string; // 名称
  functionDesc: string; // 描述
  supportSystem: string[] // 支持的系统
  channelCode: string // 渠道code 
  spaceId: string // 当前渠道所在空间ID
}
//新增jsapi
export async function addJsApi(params: IAddJsapiRequest) {
  return Requests.post(baseUrl + '/rest/intercnn/jsapi/channel/add', {
    ...params,
  })
}


/**
 * @param channelCode 渠道code
 * @param spaceId 空间code
 * @param currentPage 当前页
 * @param pageSize 一页几条
 * @param controlStatus 可选状态 CONTROLLED:已管控、UNCONTROLLED:未管控
 * @param jsapiName 可选名称搜索
 */
interface getJsApiAuthListRequest {
  channelCode: string,
  spaceId: string,
  currentPage: number,
  pageSize: number,
  controlStatus?: "CONTROLLED" | "UNCONTROLLED",
  jsapiName?: string
}
//查询渠道的jsapi列表
export async function getJsApiAuthList(params: getJsApiAuthListRequest) {
  return Requests.get(baseUrl + '/rest/intercnn/jsapi/channel/pageList', {
    ...params
  })
}


/**
 * @param spaceId 当前渠道所在空间ID
 * @param channelCode 渠道code 
 * @param jsapiList jsapi的名称列表
 */
interface IAddJsapiToAuthListRequest {
  spaceId: string; // 当前渠道所在空间ID
  channelCode: string, // 渠道code 
  jsapiList: string[] // jsapi的名称列表
}

// 添加jsapi到jsapi管控列表
export async function addJsapiToAuthList(params: IAddJsapiToAuthListRequest) {
  return Requests.post(baseUrl + "/rest/intercnn/jsapi/channel/control", { ...params })
}



/**
 * @param spaceId 当前渠道所在空间ID
 * @param channelCode 渠道code 
 * @param jsapiList jsapi的名称列表

 */
interface IRemoveJsapiToAuthListRequest {
  spaceId: string; // 当前渠道所在空间ID
  channelCode: string, // 渠道code 
  jsapiList: string[] // jsapi的名称列表
}

//从js管控列表中移除jsapi
export async function removeJsapiToAuthList(params: IRemoveJsapiToAuthListRequest) {
  return Requests.post(baseUrl + "/rest/intercnn/jsapi/channel/unControl", { ...params })
}



/**
 * @param channelCode 渠道code
 * @param spaceId 空间code
 * @param appId 小程序ID
 * @param currentPage 当前页
 * @param pageSize 一页几条
 * @param status AUTHED(通过),IN_REVIEW（审核中）,REFUSED（已拒绝）
 * @param jsapiName 可选名称搜索

 */
interface IJsApiApplyListForChannelRequest {
  channelCode: string // 渠道code
  spaceId: string // 空间code
  appId: string // 小程序ID
  currentPage: number // 当前页
  pageSize: number// 一页几条
  status?: "AUTHED" | "IN_REVIEW" | "REFUSED"  // AUTHED(通过),IN_REVIEW（审核中）,REFUSED（已拒绝）
  jsapiName?: string// 可选名称搜索
}

//查询小程序在对应渠道下的jsapi列表
export async function getJsApiApplySatusListForChannel(params: IJsApiApplyListForChannelRequest) {
  return Requests.get(baseUrl + '/rest/intercnn/jsapi/app/appliedPage', {
    ...params,
    jsapiName: encodeURIComponent(params?.jsapiName || '')
  })
}







//查询小程序可申请jsapi的列表
export async function getJsApiApplyListForChannel(params) {
  return Requests.get(baseUrl + '/rest/intercnn/jsapi/app/toApplyPage', {
    ...params,
  })
}




/**
 * @param appId 小程序ID
 * @param spaceId 当前小程序所在空间ID
 * @param channelCode 渠道code 
 * @param jsapiList jsapi的名称列表

 */

interface IApplyJsApiForChannelRequest {
  appId: string// 小程序ID
  spaceId: string,// 当前小程序所在空间ID
  applyJsapiList: Array<{ jsapiName: string, channelCode: string }>
}

// 小程序在相应渠道下申请jsapi
export async function applyJsApiForChannel(params: IApplyJsApiForChannelRequest) {
  return Requests.post("/rest/intercnn/jsapi/app/applyJsapi", { ...params })
}



// 获取当前空间下的所有发布渠道
//TODO draftStatus 什么意思
// belongSpaceId 什么意思
export async function getChannelList(params) {
  return Requests.get(baseUrl + '/rest/intercnn/publishChannel/pageQuery', {
    ...params,
    currentPage: 1,
    pageSize: 300,
  })
}




